import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';

import { openModal, closeModal } from 'actions/modal';
import { get as getParentStudentDetails } from 'actions/parent-student';
import MODAL from 'constants/modal';

import styled from 'styled-components';
import { Separator, Button, Text } from '@cuemath/comps';
import { FORM_ACTIONS, MODAL_FORM } from 'constants/form';
import { COUNTRY_OPTIONS } from 'utils';

import {
  Field,
  Input,
  Asterisk,
  Label,
  Head,
  FormWrapper,
  ButtonWrapper,
  SelectInput,
} from 'modules/form';

export const SelectInputWrapper = styled(SelectInput)`
  width: ${({ profileView }) => `${profileView ? '300px' : '340px'}`};
  height: 40px;
  padding: 5px 10px;
  outline: none;
  display: inline-block;
  &:focus {
    border: 3px solid #c4dffe;
    &::placeholder {
      opacity: 0;
    }
  }
`;

class PhoneContainer extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      closeModal: PropTypes.func.isRequired,
      getParentStudentDetails: PropTypes.func.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      phone: null,
      countryCode: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { parentStudentDetails, actions } = props;
    const { phone } = state;
    const parentStudentget = store.get(parentStudentDetails, phone);

    if (parentStudentget && parentStudentget.isLoaded) {
      const data = parentStudentget.data;
      if (data['parent'] && data['user']) {
        actions.openModal(
          MODAL_FORM.PARENTSTUDENT,
          {
            size: 'custom',
            width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
            height: MODAL.HEIGHT,
          },
          { parent: data['user'], students: data['students'] },
        );
      } else {
        actions.openModal(
          MODAL_FORM.STUDENT,
          {
            size: 'custom',
            width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
            height: MODAL.HEIGHT,
          },
          { formType: FORM_ACTIONS.CREATE, data: {} },
        );
      }
    } else if (parentStudentget && parentStudentget.isLoadingFailed) {
      return newState;
    }

    return newState;
  }

  onChange = value => {
    if (value.length > 13) return;
    this.setState({
      phone: value,
    });
  };

  changeExtension = selectedCountry => {
    this.setState({
      countryCode: selectedCountry.value,
    });
  };

  handleSubmit = () => {
    const { phone, countryCode } = this.state;
    const { actions } = this.props;
    actions.getParentStudentDetails(phone, null, { phone, country_code: countryCode });
  };

  render() {
    const { phone } = this.state;
    return (
      <React.Fragment>
        <FormWrapper>
          <Head>
            <Text size="xlarge" align="center">
              Enter Parent's Phone No.
            </Text>
          </Head>
          <Separator transparent height="25" />
          <Field key={'phone'}>
            <Label style={{ minWidth: '30%' }}>
              {'Phone Number'}
              <Asterisk>*</Asterisk>
            </Label>
            <SelectInputWrapper
              name="countryCode"
              onChange={this.changeExtension}
              options={COUNTRY_OPTIONS}
            />
            <Input
              style={{ width: '240px' }}
              name={'phone'}
              placeholder={'Enter the Phone No.'}
              type="number"
              required={true}
              value={phone}
              onChange={this.onChange}
            />
          </Field>
          <Separator height={40} transparent />
          <ButtonWrapper flexDirection="row-reverse">
            <Button label="Submit" onClick={this.handleSubmit} />
          </ButtonWrapper>
        </FormWrapper>
      </React.Fragment>
    );
  }
}

export default connect(
  ({ parentStudentDetails }) => ({ parentStudentDetails }),
  dispatch => ({
    actions: bindActionCreators(
      { closeModal, getParentStudentDetails, openModal },
      dispatch,
    ),
  }),
)(PhoneContainer);
